import axios from 'axios'

import bofhDefaultHeaders from '../bofhDefaultHeaders'
import setProfileKey from 'utils/setProfileKey'
import setRezServerFraudProtectionHeader from 'utils/setRezServerFraudProtectionHeader'
import setHttpRequestId from 'utils/setHttpRequestId'

import {
  OFFLINE_CUG_TYPE,
  SIGNED_IN_CUG_TYPE,
  SENSITIVE_CUG_TYPE
} from '@daedalus/core/src/offer/business/privateDeals'

import {getPlusCugType} from '@daedalus/core/src/offer/business/getPlusCugType'
import {getFriendAndFamilyCugType} from '@daedalus/core/src/offer/business/getFriendAndFamilyCugType'
import {PaymentOptionsResponseType} from 'types/Rooms'

import {LinkType} from '@daedalus/core/src/booking/types/Link'
import {getRooms} from '@daedalus/core/src/sapi/services'
import {getUserTierForSapi} from '@daedalus/core/src/sapi/utils'
import {sapiErrorToCommonError} from '@daedalus/core/src/sapi/services/error'

const axiosConfig = {
  headers: bofhDefaultHeaders
}

const axiosInstance = axios.create(axiosConfig)

export const getPaymentOptionsFactory = httpService => async (
  link: LinkType,
  experimentApiKey: string,
  httpRequestId: string
): Promise<PaymentOptionsResponseType> => {
  const {href} = link
  setHttpRequestId(httpService, httpRequestId)
  setProfileKey(httpService, experimentApiKey)
  setRezServerFraudProtectionHeader(httpService)
  return httpService.get(href)
}

export const fetchRoomsSapi = async ({
  hotelId,
  checkIn,
  checkOut,
  rooms,
  providerCode,
  isMemberPlus,
  isEmployee,
  isAuthenticated,
  oid
}) => {
  try {
    const defaultCugDeals = [
      OFFLINE_CUG_TYPE,
      SIGNED_IN_CUG_TYPE,
      SENSITIVE_CUG_TYPE
    ]
    const plusCugType = getPlusCugType(isMemberPlus)
    const FsfCugType = getFriendAndFamilyCugType(isEmployee)
    const cugDeals = [...defaultCugDeals, ...plusCugType, ...FsfCugType].join(
      ','
    )
    const tier = getUserTierForSapi({isAuthenticated, isMemberPlus})

    return await getRooms({
      hotelId,
      checkIn,
      checkOut,
      rooms,
      providerCode,
      cugDeals,
      tier,
      oid
    })
  } catch (error) {
    const sapiError = await sapiErrorToCommonError(error)
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw sapiError
  }
}

const fetchPaymentOptionsService = getPaymentOptionsFactory(axiosInstance)

export {fetchPaymentOptionsService}
